import '../Logo/Logo.scss'
import {Link} from 'react-router-dom'


const Logo  = (props) =>{
        return(
            <>
                <Link className="logo" to='/home'>
                    <img className="logo__icon"  src="/img/logo.png" alt="logo" />
                    <h2 className="logo__text">Store</h2>
                </Link>
            </>
        )
}

export default Logo;